export default __webpack_public_path__ + "static/runservice3-41404c65fa871022006209b289b8530d.png";